module.exports = __webpack_public_path__ + "static/media/IconWallet.f4fa751a.svg";